import React, { useEffect, useState } from 'react'
import { Modal } from '@entur/modal'
import { Fieldset, Checkbox } from '@entur/form'
import { space } from '@entur/tokens'
import { PrimaryButton, SecondaryButton } from '@entur/button'
import { FamilyMember, Fetch, FetchState, Employee } from '../../api-clients/api-types'
import { DownloadRequest } from '../../api-clients/client-hooks'
import { ModalErrorAlert } from '../modal/modal-error-alert'
import { calculateAge } from '../../utils/date-utils'

type WelcomeLetterModalProps = {
  open: boolean
  employee: Employee
  familyMembersResponse: Fetch<FamilyMember[]>
  download: (downloadRequest: DownloadRequest) => void
  downloadResponse: Fetch<undefined>
  close: () => void
}
export const WelcomeLetterModal: React.FC<WelcomeLetterModalProps> = (props) => {
  const [isDownloading, setIsDownloading] = useState(true)

  const downloadWelcomeLetter = () => {
    setIsDownloading(true)
    props.download({
      body: {
        ticketRightHolderCodes: Array.from(document.querySelectorAll('input[type=checkbox]:checked')).map(
          (element) => (element as HTMLInputElement).value
        ),
      },
      backupFileName: `velkomstbrev.pdf`,
    })
  }

  useEffect(() => {
    if (isDownloading && props.downloadResponse.status === FetchState.BLOB_SUCCESS) {
      setIsDownloading(false)
      props.close()
    }
  }, [props, isDownloading])

  return (
    <Modal
      className="welcome-letter-modal"
      data-cy="welcome-letter-modal"
      open={props.open}
      title="Skriv ut velkomstbrev"
      size="medium"
      onDismiss={props.close}
    >
      <Fieldset label="Hvem skal være med i brevet?">
        <Checkbox defaultChecked={true} value={props.employee.ticketHolderCode}>
          {`${props.employee.firstName} ${props.employee.surname} (Rettighetseier)`}
        </Checkbox>
        {props.familyMembersResponse.status === FetchState.SUCCESS &&
          props.familyMembersResponse.data
            .filter((familyMember) => {
              return (
                familyMember.relation.code !== 'Barn' || calculateAge(new Date(familyMember.dateOfBirth)) <= 18
              )
            })
            .map((familyMember) => (
              <Checkbox key={familyMember.id} value={familyMember.ticketHolderCode} defaultChecked={true}>
                {`${familyMember.firstName} ${familyMember.surname} (${familyMember.relation.code})`}
              </Checkbox>
            ))}
      </Fieldset>
      <div style={{ marginTop: space.extraLarge5 }}>
        {props.familyMembersResponse.status === FetchState.ERROR && (
          <ModalErrorAlert title="Kan ikke hente inn familiemedlemmer" />
        )}
        {props.downloadResponse.status === FetchState.ERROR && (
          <ModalErrorAlert title="Kan ikke lage velkomstbrev" />
        )}
        <PrimaryButton
          loading={props.downloadResponse.status === FetchState.LOADING}
          onClick={downloadWelcomeLetter}
          data-cy="welcome-letter-download-button"
        >
          Last ned brev
        </PrimaryButton>
        <SecondaryButton onClick={props.close} style={{ marginLeft: space.medium }}>
          Avbryt nedlastingen
        </SecondaryButton>
      </div>
    </Modal>
  )
}
